function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PowerBILogService from '@/apps/data-platform/services/power_bi_log/reports';
import StateComponent from '@/components/StateComponent.vue';
import { mapState } from 'vuex';
export default {
  name: 'LogPowerBI',
  components: {
    StateComponent: StateComponent
  },
  data: function data() {
    return {
      dashboardUrl: '',
      showDashboard: false,
      report: null,
      maintenance: false,
      titulo: 'Reporte de registro Power BI',
      tienePermiso: true
    };
  },
  created: function created() {
    this.getReport();
    this.getOrgDomain();
  },
  methods: {
    getReport: function getReport() {
      var _this = this;
      PowerBILogService.get_power_bi_log_report().then(function (response) {
        _this.report = response.data;
        _this.dashboardUrl = _this.report.link;
        _this.titulo = _this.report.title;
        _this.maintenance = _this.report.maintenance;
      });
    },
    // getOrgDomain() {
    //   PowerBILogService.get_orgs_assessment_report().then(response => {
    //     if (response.data) {
    //       response.data.forEach(element => {
    //         if (element.id === this.companyCode) {
    //           this.tienePermiso = true
    //         }
    //       })
    //     }
    //   })
    // },
    onCopyCode: function onCopyCode() {
      navigator.clipboard.writeText(this.report.code);
      this.$toast.info(this.translate('frases.code_copied'));
      this.showDashboard = true;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClassTable: function getClassTable() {
      return 'col-sm-12';
    }
  })
};